module.exports = {"id":"192620","name":"Holger Badstuber","rating":"78","photo":"./data/images/photos/0/192620.png","club":{"name":"VfB Stuttgart","logo":"./data/images/clubs/VfBStuttgart.png"},"positions":["DC","MDC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HolgerBadstuber0.json
// module id = 1747
// module chunks = 0